import { useEffect } from "react"
import { Col, Container, Row } from "react-bootstrap"
import { getTokenExternal } from "../utils/getTokenExternal"
import Get from "../api/Get"
import { GET_GENERIC_TEXT } from "../api/Routes"
import { useState } from "react"

function CitaMensaje(){
    const [genericText, setGenericText] = useState('')
    useEffect(() => {
        try {
            async function fetchTokenExternal(){
                let response = await getTokenExternal({id: 2})
                if(response.data.access_token){
                    try {
                        const resp = await Get({url: `${GET_GENERIC_TEXT}/1` , access_token: response.data.access_token})
                        if(resp.data.state){
                            setGenericText(resp.data.data.description)
                        }else{
                            setGenericText('Por favor espera la confirmación de su servicio por correo electrónico.')
                        }
                    } catch (error) {
                        setGenericText('Por favor espera la confirmación de su servicio por correo electrónico.')
                    }
                }
            }
            fetchTokenExternal();
        } catch (error) {
        }
    }, [])

    return (
        <Container fluid className="content py-5 main">
             <Row>
                <Col xs="12" md={{span: 6, offset: 3}} className="text-center">
                    <p>
                        {genericText}
                    </p>
                </Col>
            </Row>
        </Container>
    )
}

export default CitaMensaje